import { Col, Row, Button, Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const AuctionFirmSPS = ({ auctioneerDetail, address, propertyinfo, cms, state }) => {
  // const { auctioneerDetail } = data;
  // const { address } = propertyinfo;


  return (

    <div className="left_side_widget mb30 tour-pdp-details p0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' >
          Auction By:

        </h3>

      </Row>



      <div className="mt10 ml25 pb30 ">
        {/* {address.state === 'NC' && (
          <><h5 className="mt25 ml25  pdpHeadingMedium">Auctioneer</h5><p className="pdp-get-content">
            Altisource Online Auction – Real Estate Corporation License
            No. C27700
          </p></>
        )} */}
        {/* {(auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumThree && auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumOne) && (
          <>
            <p className="pdp-get-content-Auction-Firm pdpHeadingMedium "
            style={{ display: 'inline-block', cursor: 'pointer' }}
              data-tooltip-id="auctionFirmLicenseToolTio"
              data-tooltip-content=" The Auctioneer is the person responsible for running the auction pursuant to state regulations."
            >
              Auction Licenses
            </p>
            <Tooltip id="auctionFirmLicenseToolTio" place="bottom"

              style={{ fontSize: 11, width: 180, zIndex: 9999 }} />
           
          </>
        )} */}

        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtOne && (
          <p className="pdp-get-content mb-0">
            {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtOne}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumOne && (
          <p className="pdp-get-content mb-0">
            License No. {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumOne}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneOne && (
          <p className="pdp-get-content mb-0">
            {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneOne}
          </p>
        )}

         {/* <p className="pb10"></p> */}

        {/* {(auctioneerDetail.auctioneerLcnsTxtTwo ||
                auctioneerDetail.auctioneerLcnsNumTwo ||
                auctioneerDetail.auctioneerPhoneTwo) && <DividerSpan />} */}

        {/* {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumThree && (
          <>
            <p className="pdp-get-content-Auction-Firm pdpHeadingMedium pt20">
              Altisource Online Auction, Inc Real Estate Broker
            </p>

          </>
        )} */}

        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtTwo && (
          <p className="pdp-get-content mb-0 pt10">
            {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtTwo}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumTwo && (
          <p className="pdp-get-content mb-0">
            License No. {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumTwo}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneTwo && (
          <p className="pdp-get-content mb-0">
            {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneTwo}
          </p>
        )}
           {/* <p className="pb10"></p> */}

        {/* {(auctioneerDetail.auctioneerLcnsTxtThree ||
                auctioneerDetail.auctioneerLcnsNumThree ||
                auctioneerDetail.auctioneerPhoneThree) && 
                
                
                <DividerSpan />} */}

        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtThree && (
          <p className="pdp-get-content mb-0 pt10">
            {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsTxtThree}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumThree && (
          <p className="pdp-get-content mb-0">
            License No. {auctioneerDetail?.auctioneerDetail?.auctioneerLcnsNumThree}
          </p>
        )}
        {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneThree && (
          <p className="pdp-get-content">
            {auctioneerDetail?.auctioneerDetail?.auctioneerPhoneThree}
          </p>
        )}
          {/* <p className="pb10"></p> */}


     
        {auctioneerDetail?.auctionFirmDetail && (
          <>
            <p className="pdp-get-content-Auction-Firm pdpHeadingMedium pb0 pt10">
              Auction Firm
            </p>


            {auctioneerDetail?.auctionFirmDetail?.auctioneerLcnsTxtOne && (
              <p className="pdp-get-content mb-0">
                {auctioneerDetail?.auctionFirmDetail?.auctioneerLcnsTxtOne}
              </p>
            )}
            {auctioneerDetail?.auctionFirmDetail?.auctioneerLcnsNumOne && (
              <p className="pdp-get-content mb-0">
                License No. {auctioneerDetail?.auctionFirmDetail?.auctioneerLcnsNumOne}
              </p>
            )}
            {auctioneerDetail?.auctionFirmDetail?.auctioneerPhoneOne && (
              <p className="pdp-get-content mb-0">
                {auctioneerDetail?.auctionFirmDetail?.auctioneerPhoneOne}
              </p>
            )}
          </>

        )}

      </div>



    </div>
  );
};

export default AuctionFirmSPS;
